export const ADD_CART = "ADD_CART"
export const DECREASE = "DECREASE"
export const INCREASE = "INCREASE"
export const REMOVE = "REMOVE"
export const REMOVE_ITEM = "REMOVE_ITEM"
export const CLEAR_CART = "CLEAR_CART"
export const GET_TOTAL = "GET_TOTAL"
export const GET_AMOUNT = "GET_AMOUNT"
